module.exports = __webpack_public_path__ + "static/media/bottomimg.5a808055.png";